export const handleClick = () => {
  const element = document.getElementById('contact-us')
  return element?.scrollIntoView({
    behavior: 'smooth',
  })
}
